import React from 'react'
import { fmtReceived } from '../lead-inspector/model'
import ReasonPill from './ReasonPill'
import { count } from './model'

// "Latest blocked submissions": one page (25) of the range's rejections,
// newest first. Partner, reason and detail are exactly what the backend
// sent; there is no lead behind a row, so nothing here links to one.
export default function LatestTable({ data, timezone, onView, onPage }) {
  const rows = data.rows || []
  const from = rows.length ? (data.page - 1) * data.page_size + 1 : 0
  const to = from ? from + rows.length - 1 : 0

  return (
    <section className="card" aria-labelledby="bk-latest-title" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <h2 id="bk-latest-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Latest blocked submissions</h2>
      {rows.length === 0 ? (
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>
          {data.page > 1 ? 'No more blocked submissions on this page.' : 'No submissions were blocked in this range.'}
        </p>
      ) : (
        <div className="bk-table-scroll">
          <table className="bk-table">
            <thead>
              <tr>
                <th scope="col">Received (ET)</th>
                <th scope="col">Partner</th>
                <th scope="col">Reason</th>
                <th scope="col" className="bk-hide-sm">Detail</th>
                <th scope="col" aria-label="Actions" />
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.event_id}>
                  <td style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{fmtReceived(r.received_at, timezone)}</td>
                  <td style={{ fontWeight: 600 }}>{r.partner?.name || '—'}</td>
                  <td><ReasonPill reason={r.reason} /></td>
                  <td className="bk-hide-sm" style={{ color: 'var(--text-secondary)', maxWidth: 360, overflowWrap: 'anywhere' }}>{r.detail || '—'}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-ghost btn-sm" style={{ whiteSpace: 'nowrap' }} onClick={() => onView(r.event_id)}>
                      View details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {(rows.length > 0 || data.page > 1) && (
        <nav aria-label="Pagination" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            {rows.length ? `${count(from)}–${count(to)} of ${count(data.total)}` : `${count(data.total)} in total`}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn btn-ghost btn-sm" disabled={data.page <= 1} onClick={() => onPage(data.page - 1)}>Newer</button>
            <button type="button" className="btn btn-ghost btn-sm" disabled={data.page >= data.total_pages} onClick={() => onPage(data.page + 1)}>Older</button>
          </div>
        </nav>
      )}
    </section>
  )
}
